var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t("TODO_LIST")))])]),_c('create'),_c('filter-bar'),_c('list',{ref:"TodoList",on:{"showJobEmit":function($event){return _vm.getData($event)}}},[_c('p',[_vm._v("Emit: "+_vm._s(_vm.emit))])]),_c('paging-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }